import { ConnectedPosition } from '@angular/cdk/overlay';
import { ToolTipPositions } from '@sb/tooltip';

export enum PopoverPlacement {
  TOP = 'top',
  TOP_LEFT = 'top-left',
  TOP_RIGHT = 'top-right',
  BOTTOM = 'bottom',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_RIGHT = 'bottom-right',
  LEFT = 'left',
  LEFT_TOP = 'left-top',
  LEFT_BOTTOM = 'left-bottom',
  RIGHT = 'right',
  RIGHT_TOP = 'right-top',
  RIGHT_BOTTOM = 'right-bottom',
}
export type popoverPlacement = `${PopoverPlacement}`;

export type popoverTrigger = 'click' | 'hover';

export const PopoverPositions: Record<PopoverPlacement, ConnectedPosition> = {
  [PopoverPlacement.TOP]: {
    ...ToolTipPositions.top,
    panelClass: ['sb-popover-top'],
  },
  [PopoverPlacement.TOP_RIGHT]: {
    ...ToolTipPositions['top-right'],
    panelClass: ['sb-popover-top-right'],
  },
  [PopoverPlacement.RIGHT]: {
    ...ToolTipPositions.right,
    panelClass: ['sb-popover-right'],
  },
  [PopoverPlacement.RIGHT_TOP]: {
    originX: 'end',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'top',
    offsetX: 20,
    panelClass: ['sb-popover-right-top'],
  },
  [PopoverPlacement.RIGHT_BOTTOM]: {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'bottom',
    offsetX: 20,
    panelClass: ['sb-popover-right-bottom'],
  },
  [PopoverPlacement.BOTTOM_RIGHT]: {
    ...ToolTipPositions['bottom-right'],
    panelClass: ['sb-popover-bottom-right'],
  },
  [PopoverPlacement.BOTTOM]: {
    ...ToolTipPositions.bottom,
    panelClass: ['sb-popover-bottom'],
  },
  [PopoverPlacement.BOTTOM_LEFT]: {
    ...ToolTipPositions['bottom-left'],
    panelClass: ['sb-popover-bottom-left'],
  },
  [PopoverPlacement.LEFT]: {
    ...ToolTipPositions.left,
    panelClass: ['sb-popover-left'],
  },
  [PopoverPlacement.LEFT_BOTTOM]: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'bottom',
    offsetX: -20,
    panelClass: ['sb-popover-left-bottom'],
  },
  [PopoverPlacement.LEFT_TOP]: {
    originX: 'start',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'top',
    offsetX: -20,
    panelClass: ['sb-popover-left-top'],
  },
  [PopoverPlacement.TOP_LEFT]: {
    ...ToolTipPositions['top-left'],
    panelClass: ['sb-popover-top-left'],
  },
};

export const MouseMoveAuditTime = 300;

export enum PopoverTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export type popoverTheme = `${PopoverTheme}`;
